// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__SaDkv","info":"PatientInfo_info__2QqZk"};